/**
 * @file
 * @copyright  2017 Subscribe-HR
 */

/**
 * Subscribe-HR abstract condition class
 */
export default class ConditionAbstract {

  /**
   * Create condition
   * @param {string} type, AND or OR
   */
  constructor(type = null) {
    this.setType(type);
  }

  /**
   * Set condition type
   * @param {string} type, AND or OR
   */
  setType = (type) => {
    this.type = type;
  }

  /**
   * Get condition type
   * @return {string}
   */
  getType = () => {
    return this.type;
  }
}



// WEBPACK FOOTER //
// ./src/client/common/js-subscribe-sdk/lib/Entities/ConditionAbstract.js